import { QueryClient } from 'react-query';

export default new QueryClient();
